import {
  retryWithoutFallback,
  LoadFn,
  LoadFnResult,
} from './retryWithoutFallback'

export function retry<TProps>(
  fn: LoadFn<TProps>,
  retriesLeft = 10,
  interval = 500,
): Promise<LoadFnResult<TProps>> {
  try {
    return retryWithoutFallback(fn, retriesLeft, interval)
  } catch (e) {
    return import('@surglogs-app/connection-failed').then(
      ({ ConnectionFailed }) => ({ default: ConnectionFailed }),
    )
  }
}
